import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { AlertService } from 'services/alert.service';
import { NavigationService } from 'services/navigation.service';
import { UserService } from 'services/user.service';
import { UserSessionService } from 'services/usersession.service';

@Component({
  selector: 'app-salesreppopup',
  templateUrl: './salesreppopup.component.html',
  styleUrls: ['./salesreppopup.component.scss']
})
export class SalesreppopupComponent implements OnInit {
  salesform: FormGroup;
  // form:FormGroup;
  // routeParams: any;
  id: 0;
  // userid:0;
  actionInfo: any;
  routeParams: any;
  submitbtn: string;
  formEditMode: boolean;
  data: any;
  isReadOnly: boolean;
  isDisable: boolean;
  rep: any;
  
  // formBuilder: any;
  // id:string;
  // isAddMode:boolean;
  // submitted: boolean;
  // loading:boolean;

  constructor(private alertService:AlertService ,private activateroute:ActivatedRoute
    , private usersession:UserService, private userService: UserService,private formBuilder: FormBuilder
    , private userSessionService: UserSessionService, private navigationService:NavigationService  ) {

    // this.usersession = this.userSessionService.getUserSession();


  }

  ngOnInit() {
    
    this.routeParams = this.activateroute.snapshot.params;
    this.id = this.routeParams.id;
    this.actionInfo = this.routeParams.actionInfo

    // this.userid=this.routeParams.id;
    // this.id = this.route.snapshot.params['id'];
    // this.isAddMode = !this.id;
    this.get(true);

    this.initializeValidators();
    // this.getTitleType(true);
    // this.getUserDetails(true);

  //   if (!this.isAddMode) {
  //     this.userService.getsalesdetail(this.id, this.salesform.value)
  //         .pipe(first())
  //         .subscribe(result => this.salesform.patchValue(result));
  // }

  }
  // get f() { return this.salesform.controls; }

  initializeValidators() {

    this.salesform = this.formBuilder.group({
      id: [this.id, Validators.required],
      salesRepCode: ['', [Validators.required]],
      salesRepName: ['', [Validators.required]],
       });

       if (this.id === 0) {
        this.submitbtn = 'Save';
      } else {
        this.submitbtn = 'Update';
      }
      if (this.actionInfo == 1) {
        this.formEditMode = false
      }

  }

onSave(){
  this.userService.salesdetail(this.salesform.value).subscribe(
    result=>{
      this.navigationService.goToGrid();
    }
  )
}


get(refresh: boolean) 
{
  if (this.id > 0) {
    this.userService.GetById(this.id, refresh).subscribe(result => {
      this.data = result;
      if(this.data)
      {
          this.salesform.patchValue(this.data);
          if (this.formEditMode === false) {
            this.isReadOnly = false;
            this.salesform.disable();
            this.isDisable = true;
            //this.isReadOnly = false;
          }
        }   
        else if(result.failures[0] === "data already exists")
          {
            this.alertService.warning('data  already exists');
          } 
        // set isDisabled(value: boolean) {
        //   this._isDisabled = value;
        //   if(value) {
        //    this.form.controls['name'].disable();
        //   } else {
        //      this.form.controls['name'].enable();
        //    }
        //  } 
    });
    this.isReadOnly = true;
  }
}

onClose(){
  this.navigationService.goToGrid();
}
}
